// Animations
// ----------
import { gsap, Power1, Sine, Linear } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

(function ($) {
    const $body = $('body');

    $(function () {
        // Homepage header animation
        // -------------------------
        if (localStorage.homepageVisit) {
            $('body.page--homepage').addClass('page--homepage-visited');
        } else {
            $('body.page--homepage').addClass('page--homepage-first-visit');
            localStorage.setItem('homepageVisit', 'true');
        }
        $('.page--homepage-first-visit #header').each(function () {
            const tlHeader = new gsap.timeline();
            tlHeader.to(this, .6, { opacity: 1, yPercent: 20, ease: Power1.easeOut }, '+=2.2');
        });

        // Introduction curtain
        // -----------------------------------
        $('.page-header--animation-active').each(function () {
            const tl = new gsap.timeline(),
                $this = $(this),
                $curtain = $this.find('.page-header-curtain'),
                $text = $this.find('.text--anm'),
                $outer = $text.find('.outer');

            // No text, faster animation
            let curtainDuration = '+=1.5',
                textDuration = '-=1.5';
            if ($($text).length) {
                curtainDuration = '+=2.3';
                textDuration = '-=1.5';
            }

            tl.to($curtain, .6, { height: '85vh', ease: Sine.easeOut }, curtainDuration);
            if ($outer.length > 0) {
                tl.to($outer, 1, { opacity: 1 }, textDuration);
            }
            tl.to(this, .1, { zIndex: '1' }); // helper, change z-index for the case-overview section.
        });

        // Split heading text
        // -----------------------------------
        $('.title--anm, .subtitle--anm').each(function () {
            const tl = new gsap.timeline(),
                $this = $(this),
                $inner = $this.find('.inner'),
                $outer = $this.find('.outer');

            tl.to($outer, 0.25, { opacity: 1 });
            tl.from($inner, 1, { yPercent: 100, ease: Power1.easeOut });
        });

        // Case nav fade out
        // -----------------------------------
        $('.case-link--nav').click (function (evt) {
            const $link = $(this);
            $('.case-navigation').addClass('is-clicked');

            evt.preventDefault();
            const linkURL = $link.attr('href');

            const tl = new gsap.timeline();
            tl.to(window, {duration: .4, scrollTo: '.case-navigation'});
            tl.to($link, 0.5, { opacity: 0 }, '+=0.4');

            setTimeout(function () {
                window.location.href = linkURL
            }, 1200); // delay for animation time

            // Cleanup/revert, needed for Safari back-button
            $(window).bind('pagehide', function (evt) {
                tl.set($link, { css: { opacity: 1 } });
                $('.case-navigation').removeClass('is-clicked');
            });
        });

        // Parallax section
        // -----------------------------------
        $('section.visual').each(function () {
            const $section = $(this).find('.parallax-container > div');
            if ($section.length == 0) {
                return;
            }

            const tl = new gsap.timeline({
                    scrollTrigger: {
                        trigger: this,
                        scrub: 0.5,
                        start: 'top bottom',
                        end: 'bottom top'
                    }
                });

            tl
                .addLabel('start')
                .to($section, 0.5, { yPercent: 80, ease: Linear.easeNone }, 'start');

            const $borders = $(this).find('.border-left, .border-right');
            if ($borders.length > 0) {
                tl.to($borders, 0.25, { width: '0%', ease: Linear.easeNone }, 'start')
            }
        });



        // Horizontal pins
        // -----------------------------------
        $('section.work-method-overview').each(function () {
            const $container = $(this).find('.work-method-pin-container'),
                $sections = $container.find('.work-method');

            gsap.to($sections, {
                xPercent: -100 * ($sections.length - 1),
                ease: 'none',
                scrollTrigger: {
                    trigger: $container,
                    pin: true,
                    scrub: 0.1,
                    end: () => "+=" + $container[0].offsetWidth
                }
            });
        });


        // Change color of the site logo
        // -----------------------------------

        const logoOffset = $('#site-logo').position().top + $('#site-logo').height();

        $('section.is-light, footer#footer').each(function () {
            const tl = gsap.timeline(),
                $element = $(this);
            tl.to($element, {
                scrollTrigger: {
                    trigger: $element,
                    start: 'top ' + logoOffset + 'px',
                    end: 'bottom ' + logoOffset + 'px',
                    onToggle: ({isActive}) => $body.toggleClass('header-invert', isActive),
                    scrub: true
                }
            });
        });

        // White section
        $('section.is-white').each(function () {
            const tl = gsap.timeline(),
                $element = $(this);
            tl.to($element, {
                scrollTrigger: {
                    trigger: $element,
                    start: 'top ' + logoOffset + 'px',
                    end: 'bottom ' + logoOffset + 'px',
                    onToggle: ({isActive}) => $body.toggleClass('white-section', isActive),
                    scrub: true
                }
            });
        });


        // Fade in/out images
        // ------------------
        $('.bg-img--anm, .fig-anm').each(function () {
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: this,
                    scrub: true,
                    start: 'top bottom',
                    end: 'bottom top'
                }
            });

            tl
                .addLabel('start')
                    .from(this, { opacity: 0, yPercent: 20 })
                .addLabel('mid')
                    .to(this, { opacity: 1, yPercent: 0 })
                .addLabel('end')
                    .to(this, { opacity: 0 });
        });
    });
})(jQuery);
